import React, { useState, useEffect, useContext } from "react";
import SubscriptionCard from "../Layout/SubscriptionCard";
import axios from "axios";
import OverLay from "./Modals/OverLay";
import { GlobalContext } from "../../Context/GlobalContext";
import { getSubscriptions } from "../../Helpers/api";
import { useLocation, Redirect, Link } from "react-router-dom";

const Subscriptions = ({ companyName }) => {
  const API_URL = "https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com";

  const [visible, setVisible] = useState(true);
  const {
    viewerObj,
    connectedStripeId,
    subscriptions,
    ownerOfVODId: publicUserId,
    setSubscriptions,
    subscriptionSubModel,
    setSubscriptionSubModel,
    setViewerObj,
    companyEndpoint,
  } = useContext(GlobalContext);

  const { state } = useLocation();

  const moveToHome = () => {
    window.location.href = window.location.href
      .split("/")
      .slice(0, -1)
      .join("/");
  };

  useEffect(() => {

      (async () => {
        if (publicUserId) {
          const { data: subscriptionsList } = await getSubscriptions({
            publicUserId,
          });
          const sub_array = [];
          if (subscriptionsList?.subModel && ((subscriptionsList?.subModel == 'tier' && subscriptionsList?.tiers) || (subscriptionsList?.subModel == 'custom' && subscriptionsList?.customSubs))) {
            setSubscriptionSubModel(subscriptionsList?.subModel)
            for (const key in (subscriptionsList?.subModel == 'tier'? subscriptionsList?.tiers : subscriptionsList?.customSubs)) {
              if (
                subscriptionsList?.subModel == 'tier' &&
                subscriptionsList?.tiers.hasOwnProperty(key) &&
                (!state?.associatedSubscriptions ||
                  state?.associatedSubscriptions.hasOwnProperty(subscriptionsList?.tiers?.[key]?.product_Id))
              ) {
                sub_array.push({
                  ...subscriptionsList?.tiers[key],
                  type: key,
                });
              }
              else if (
                subscriptionsList?.subModel == 'custom' &&
                subscriptionsList?.customSubs.hasOwnProperty(key) &&
                (!state?.associatedSubscriptions ||
                  state?.associatedSubscriptions.hasOwnProperty(key))
              ) {

                sub_array.push({
                  ...subscriptionsList?.customSubs[key],
                  product_Id:key
                });
              }
            }
          }
          setSubscriptions(sub_array.length?[...sub_array]:[]);
          setVisible(false);
        }
      })();
  }, [publicUserId]);

  const updateSubscription = async (newSubscription) => {
    setVisible(true);
    const { data, error } = await axios.post(`${API_URL}/update-subscription`, {
      price_Id: newSubscription.price_Id,
      product_Id: newSubscription.product_Id,
      subscriptionId: viewerObj.subscription.id,
      connectedStripeId,
      subModel:subscriptionSubModel,
      ...(subscriptionSubModel == 'tier' && {newSubscriptionPrice: parseInt(newSubscription.price)})
    });
    if (data) {
      if (data?.data) {
        setViewerObj({ ...viewerObj, subscription: data.data.subscription });
        moveToHome();
      }
    }
    setTimeout(() => setVisible(false), 100);
  };

  const checkOut = async ({ price_Id, product_Id, ...item }) => {
    setVisible(true);
    try {
      const { data, error } = await axios.post(
        `${API_URL}/create-checkout-session`,
        {
          stripeId: viewerObj.stripeId,
          connectedStripeId,
          subModel:subscriptionSubModel,
          price_Id,
          viewerEmail: viewerObj.email,
          product_Id,
          viewerId: viewerObj._id,
          companyName,
        }
      );
      setVisible(false);
      window.location.href = data.sessionURL;
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // return the non logged in user to the home menu
  // if (!viewerObj) {
  //   return <Redirect to={`/${companyEndpoint || companyName}`} />;
  // }

  return (
    <div className="height-controller">
      <Link
        style={{
          position: "absolute",
          right: 20,
          top: 10,
          cursor: "pointer",
          textDecoration: "none",
        }}
        to={`/${companyEndpoint}`}
      >
        <div className="back-button">
          <span className="card-button-text">Move to home</span>
        </div>
      </Link>
      <OverLay visible={visible} />
      <div
        className="pl-2 card-container"
        style={{
          height: "100%",
          alignItems: "center",
          backgroundColor: "#f0f0f0",
        }}
      >
        <p className="heading heading-600">Subscriptions</p>
        <p className="sub-heading">
          Purchase a subscription to access advance features.
        </p>
        <div className="card-grid">
          {subscriptions.map((item, key) => (
            <SubscriptionCard
              key={key}
              {...item}
              hover
              glow
              buttonIcon={() => <i className="fas fa-unlock fa-1x icon" />}
              onClick={() => {
                if (
                  state?.associatedSubscriptions &&
                  viewerObj?.subscription?.id
                ) {
                  updateSubscription({ ...item });
                } else {
                  checkOut({ ...item });
                }
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default Subscriptions;
